<section class="fw-section mt-5" style="background-image: url(assets/img/404-bg.webp);">
  <h1 class="display-404 text-center text-info">404</h1>
</section>
<div class="container pb-3 mb-1">
  <div class="text-center">
    <h2>Page Not Found</h2>
    <p>It seems we can’t find the page you are looking for. <a [routerLink]="['/']">Go back to Homepage</a><br>Or try using search at the top right corner of the page.</p>
  </div>
</div>